import React, { useState } from "react";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { jwtDecode } from "jwt-decode";
import GoogleLoginButton from "../components/GoogleLoginButton";

function LoginPage() {
  const [user, setUser] = useState(null);
  const [tokens, setTokens] = useState({
    accessToken: null,
    refreshToken: null
  });
  const navigate = useNavigate();

  const handleLoginSuccess = async (response) => {
    if (response?.credential) {
      try {
        const { data } = await axios.post("https://comparative-ranice-brainyeti-d6d7e854.koyeb.app/auth/google-login/", {
          access_token: response.credential,
        });
        
        const decodedToken = jwtDecode(data.access_token);
        const userEmail = decodedToken.email;

        // Store tokens in state
        setTokens({
          accessToken: data.access_token,
          refreshToken: data.refresh_token
        });
        
        // Store tokens in localStorage
        localStorage.setItem("token", data.access_token);
        localStorage.setItem("refreshToken", data.refresh_token);

        setUser({ email: userEmail });

        // Remove or comment out the navigate function to stay on the login page
        navigate("/dashboard");

      } catch (error) {
        console.error("Error during login:", error);
      }
    } else {
      console.error("No credential received from Google");
    }
  };

  return (
    <GoogleOAuthProvider clientId="92307471169-4673crr0n3d8drojs8tu9hpo3rjmq9c3.apps.googleusercontent.com">
      <div style={{ padding: '20px' }}>
        <h1>Login</h1>
        <GoogleLoginButton onSuccess={handleLoginSuccess} />
        {user && <p>Logged in as {user.email}</p>}
        {tokens.accessToken && <p>Access token: {tokens.accessToken}</p>}
        {tokens.refreshToken && <p>Refresh token: {tokens.refreshToken}</p>}
      </div>
    </GoogleOAuthProvider>
  );
}

export default LoginPage;